import React from 'react';
import { connect } from 'react-redux';

// Actions
import { onSetQuestionSelected } from '../../actions/integrations';

// UI kit
import { Progress, Eyebrow } from '@/components/ui';

const Step2WelcomeQuestion = (props) => {

    // Actions
    const { onSetQuestionSelected } = props;

    // External props
    const { handleChange } = props;

    const questionArray = [
        {
            text: 'De 1 a 5',
            id: 0
        },
        {
            text: 'De 6 a 10',
            id: 1
        },
        {
            text: 'De 11 a 30',
            id: 2
        },
        {
            text: 'De 31 a 50',
            id: 3
        },
        {
            text: '+50',
            id: 4
        }
    ]

    const onSelectQuestion = (question) => {
        onSetQuestionSelected({ SelectedQuestion2: question });
        handleChange();
    }

    return (
        <div>
            <div className="mb-8">
                <div className="mb-2 flex items-center justify-between">
                    <Eyebrow>Onboarding</Eyebrow>
                    <span className="text-xs font-semibold tabular-nums text-muted-foreground">Paso 2/2</span>
                </div>
                <Progress value={ 100 } />
            </div>
            <h2 className="text-center text-lg font-bold tracking-[-0.01em] text-foreground text-balance">
                ¿Cuantas consultas recibís por día aproximadamente?
            </h2>
            <div className="mt-6 flex flex-col gap-2.5">
                {
                    questionArray.map( question => (
                        <button
                            type="button"
                            key={ question.id }
                            onClick={ () => onSelectQuestion(question.text) }
                            className="w-full rounded-sm border border-border bg-secondary px-4 py-3 text-center text-sm text-foreground transition-all duration-200 ease-out hover:border-primary hover:bg-primary-tint hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                        >
                            { question.text }
                        </button>
                    ))
                }
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        onSetQuestionSelected: (data) => dispatch( onSetQuestionSelected(data) ),
    }
}

export default connect(null, mapDispatchToProps)( Step2WelcomeQuestion );
